export function SlidingPanel() {

  this.init = ({parent, title, name, content, destroyOnClose = true, closable = true, isOpen = false} = {}) => {

    this.props = {
      parent,
      title,
      name,
      content,
      destroyOnClose,
      closable
    };

    this.state = {
      isOpen
    };

    this.render();
  };

  this.topValue = () => {
    const headerContainer = cube.$('#container-header, .container-header');
    const header = headerContainer ? headerContainer.querySelector('#header') : null;
    const headerHeight = headerContainer ? headerContainer.offsetHeight : 0;
    let messageHeight = cube.$id('top-message-bar') ? cube.$id('top-message-bar').offsetHeight : 0;
    if (header && header.classList.contains('sticky')) {
      messageHeight = 0;
    }
    return headerHeight + messageHeight;
  };

  this.render = () => {
    this.container = document.createElement('div');
    this.container.className = 'dkt-sliding-panel';
    this.container.id = this.props.name;
    this.container.setAttribute(`data-tnr-${this.props.name}`, ''); // NRT
    this.container.innerHTML = `<div class="dkt-sliding-panel-header">
      <h1 class="dkt-sliding-panel-title">${this.props.title}</h1>
      <button class="dkt-sliding-panel-close">Close</button>
    </div>
    <div class="dkt-sliding-panel-inner"></div>`;

    const inner = this.container.querySelector('.dkt-sliding-panel-inner');
    if (this.props.content instanceof Object)
      inner.appendChild(this.props.content);
    else
      inner.innerHTML = this.props.content;

    this.overlay = document.createElement('div');
    this.overlay.className = 'dkt-sliding-panel-overlay';
    this.container.style.top = `${this.topValue()}px`;
    document.body.appendChild(this.overlay);
    document.body.appendChild(this.container);
    this.closeButton = this.container.querySelector('.dkt-sliding-panel-close');
    this.events();
    setTimeout(this.open.bind(this), 1);
  };

  this.events = () => {
    if(this.props.closable === true) {
      this.closeButton.addEventListener('click', this.close);
      this.overlay.addEventListener('click', this.close);
    } else {
      this.closeButton.removeEventListener('click', this.close);
      this.overlay.removeEventListener('click', this.close);
    }
  };

  /**
   * Change the closable property of the panel to true
   * display close button
   * and re-binds events
   */
  this.setClosable = () => {
    this.props.closable = true;
    this.closeButton.classList.remove('dkt-sliding-panel-close--hidden');
    this.events();
  };

  /**
   * Change the closable property of the panel to false
   * hide close button
   * and re-binds events
   */
  this.setUnclosable = () => {
    this.props.closable = false;
    this.closeButton.classList.add('dkt-sliding-panel-close--hidden');
    this.events();
  };

  this.close = () => {
    if (this.state.isOpen === true) {
      document.body.classList.remove('panel-open');
      document.body.classList.add('panel-close');
      cube.$tag('html')[0].classList.remove('noscroll');
      this.state.isOpen = false;
      if(this.props.destroyOnClose)
        this.container.addEventListener('animationend', this.deleteElements);

      cube.event.send('closeSlidingPanel');
    }
  };

  this.deleteElements = event => {
    if (event.target === this.container) {
      this.state.isOpen = false;
      document.body.classList.remove('panel-close');
      this.container.parentNode.removeChild(this.container);
      this.overlay.parentNode.removeChild(this.overlay);
      if (this.props.parent && this.props.parent.onPanelClose)
        this.props.parent.onPanelClose();
    }
    this.container.removeEventListener('animationend', this.deleteElements);
  };

  this.open = () => {
    window.scrollTo(0, 0);
    this.state.isOpen = true;
    this.container.style.top = `${this.topValue()}px`;
    document.body.classList.remove('panel-close');
    document.body.classList.add('panel-open');
    cube.$tag('html')[0].classList.add('noscroll');
    if (this.props.parent && this.props.parent.onPanelOpen)
      this.props.parent.onPanelOpen();

    cube.event.send('openSlidingPanel');
  };
}



// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/sliding-panel.js